<template>
  <div class="bg-white">
    <div class="action-btn-block p-1 border-b bg-yellow-200">
      <div class="px-10 w-full flex justify-between">
        <button @click="$router.go(-1)" class="btn">{{ $t('Back') }}</button>
        <div>
          <button @click="print('210mm', '297mm')" class="btn">A4</button>
          <template v-for="(size, index) in $store.state.settings.printer_sizes">
            <button :key="index" @click="print(size, '200mm')" class="btn">
              {{ size }}
            </button>
          </template>
        </div>
      </div>
    </div>
    <div class="flex justify-center p-1">
      <loading :status="loading"></loading>
      <div class="invoice-box p-4 my-1">
        <div class>
          <qr-code :size="100" :text="`${currentUrl}/track/${repair.tracking}`"></qr-code>
          <h4 class="text-1 font-bold py-2 tracking-wider uppercase"> {{ $t('Invoice') }} #{{ repair.tracking }} </h4>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Invoice date') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.created_at }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Brand') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.brand }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase">{{ $t('Name') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.device.name }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Model') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.device.model }}</div>
          </div>
          <div class="mb-1 flex items-center">
            <label class="w-32 block font-bold text-xs uppercase tracking-wide">{{ $t('Serial number') }}</label>
            <span class="mr-4 inline-block">:</span>
            <div>{{ repair.serial_number }}</div>
          </div>
        </div>
        <div class="flex justify-between my-2">
          <div class="w-full pt-2">
            <label class="block mb-1 font-bold text-xl uppercase tracking-wide">{{ $t('From') }}:</label>
            <div class="text-sm">
              <div>
                <strong>{{ $t('Name') }}:</strong>
                {{ repair.name | capitalize }}
              </div>
              <div>
                <strong>{{ $t('Email') }}:</strong>
                {{ repair.email }}
              </div>
              <div>
                <strong>{{ $t('Phone') }}:</strong>
                {{ repair.phone }}
              </div>
              <div>
                <strong>{{ $t('Address') }}:</strong>
                {{ repair.address }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="
            mt-2
            flex flex-wrap
            py-2
            items-start
          "
        >
          <div class="mb-1">
            <label class="block mb-1 font-bold text-xl uppercase tracking-wide">{{ $t('Dispatched To') }}:</label>
            <h2 class="text-3xl font-bold pb-2 tracking-wider uppercase">
              {{ $store.state.settings.name }}
              <small class="text-sm">
                <p>{{ $store.state.settings.phone }}</p>
                <p>{{ $store.state.settings.address }}</p>
              </small>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueQRCodeComponent from 'vue-qrcode-component';

export default {
  name: 'dispatch-info',
  metaInfo() {
    return {
      titleTemplate: this.$store.state.settings.name,
    };
  },
  components: { 'qr-code': VueQRCodeComponent },
  data() {
    return {
      loading: true,
      currentUrl: window.app.url,
      repair: {
        device: {
          model: null,
          name: null,
        },
        defects: [],
        priority: {},
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    print(w, h) {
      const element = document.createElement('style');
      element.innerHTML = `@page { margin: 0; size : ${w} ${h} }`;
      document.head.appendChild(element);
      window.print();
    },
    get() {
      axios
        .get(route('repair-dispatch.print', this.$route.params.id))
        .then((response) => {
          this.repair = response.data.repair;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped="">
.invoice-box {
  font-family: monospace;
  width: 80%;
  font-size: 12px;
}

@media print {
  .invoice-box {
    width: 100%;
  }

  .action-btn-block {
    display: none;
  }
}
</style>
